import { minutesToHours, getMonth, getYear } from 'date-fns';
export var minsToHours = function (value) {
    var hours = minutesToHours(value);
    var mins = value - hours * 60;
    return { hours: hours, mins: mins };
};
export var createTimeText = function (timeSpent) {
    var _a = minsToHours(timeSpent), hours = _a.hours, mins = _a.mins;
    var hoursText = hours ? hours + " h " : '';
    var minsText = '';
    if (mins)
        minsText = mins + " min";
    else
        minsText = hours ? '' : '< 1 min';
    var summary = "" + hoursText + minsText;
    return summary;
};
export var getCurrentAcademicYear = function () {
    var currentDate = new Date();
    var month = getMonth(currentDate);
    var year = getYear(currentDate);
    var academicYear = month <= 6
        ? year - 1 + "-" + String(year).slice(-2)
        : year + "-" + String(year + 1).slice(-2);
    return academicYear;
};
export var shouldStudentHasAssignments = function (kinds) {
    return Boolean(kinds === null || kinds === void 0 ? void 0 : kinds.includes('extra_practice'));
};
